import { themeColors } from '../../../themeColors';
import BackButton from "@/components/Common/BackButton";
import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import RadioButtonGroup from "../../Common/RadioButtonGroup";
import {
  BOTH_TITLE,
  PROPERTY_MANAGER,
  REAL_ESTATE_AGENT,
  USER_INFO_KEY,
} from "../../../constants/common";
import { getLocalStorage } from "../../../helpers/common";

const AgentTitleModal = (props) => {
  const {
    show,
    handleAgentContinueClick,
    handleTitleClick,
    selectedTitle,
    handleUserTypeModal,
    setAgentTitleModal,
    hideBackButton,
    onCancel,
  } = props;
  const itemArray = [
    { text: "Real Estate Agent", id: REAL_ESTATE_AGENT },
    { text: "Property Manager", id: PROPERTY_MANAGER },
    { text: "Both", id: BOTH_TITLE },
  ];
  const title =
    selectedTitle ||
    _.get(getLocalStorage(USER_INFO_KEY), "userInfo.agentTitle");
  return (
    <Modal
      show={show}
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      className="modal-custom-width"
      onHide={onCancel}
    >
      <Modal.Body className="pb-32 pt-32">
        {onCancel && (
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onCancel}
          ></button>
        )}
        {!hideBackButton && (
          <>
            <BackButton onClick={() => {
                handleUserTypeModal({ showModal: true });
                setAgentTitleModal(false);
              }} />
            <br /> <br />
          </>
        )}
        <h3 className="text-start">Let’s create your profile!</h3>
        <p className="mb-30 ln-24 f-size-16 para-color-first">
          We’re here to help you meet your real estate goals. Let’s get started
          by setting up your profile.
        </p>
        <p className="f-size-16 f-medium mb-3 para-color-second">
          What's your current title?
        </p>
        <div className="wantad-timing-wrap">
          <RadioButtonGroup
            list={itemArray}
            onChange={(e) => handleTitleClick(e)}
            selectedValue={title}
          />
        </div>
        <Button
          variant="primary"
          className={title ? "btn w-100 mb-2" : "btn w-100 mb-2 disabled"}
          onClick={() => handleAgentContinueClick()}
        >
          Continue
        </Button>

        {onCancel && (
          <Button
            variant="link"
            className="btn w-100 onboarding-skip-link"
            onClick={onCancel}
          >
            I'll do this later
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AgentTitleModal;